//export const ActivityReportLinkDOOH = "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/report/Nature/Nature_Deal_report_v3.xlsx";

const creative = [
    {
        "_id": "6457540de8d1455f3068fa81",
        "ad_name": "Ocean Spray Portrait",
        "width": "1080",
        "height": "1920",
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "accountName": "Nature",
        "dimension": "1080x1920",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Image",
        "dimensionId": "62",
        "superFormatId": "12",
        "ad_id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535g",
        "creative_id": "ZTECnMK3hbX2fmz8",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/ZTECnMK3hbX2fmz8/settings.json?c8c5f61e3a5b58405fd80d2eea9545c0a4a1def2\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"ZTECnMK3hbX2fmz8\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.31.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "Ocean Spray DOOH",
        "default_landingURL": "https://bigads.co",
        "createAt": "2025-05-07 07:32:30",
        "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457540de8d1455f3068fa81/1 (1).png",
                "createAt": "2025-05-07 07:32:30",
                "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2025-05-07 07:32:30",
        "scripts": {
            //eslint-disable-next-line
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"ALOcXiARf3KF\"\r\n\tdata-unit=\"ALOcXiARf3KF\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/ALOcXiARf3KF/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n",
            "adcId": "6457540de8d1455f3068fa81"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 1
    },
    {
        "_id": "6457537e4ef20d6f92219d51",
        "ad_name": "Ocean Spray Landscape",
        "width": "1920",
        "height": "1080",
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "accountName": "Nature",
        "dimension": "1920x1080",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Image",
        "dimensionId": "64",
        "superFormatId": "19",
        "ad_id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535g",
        "creative_id": "JmRyUGAVB41JAWU6",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/JmRyUGAVB41JAWU6/settings.json?a2c117e586b1260a4f7ca1e5ce511009c5f5c26d\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"JmRyUGAVB41JAWU6\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.31.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "Ocean Spray",
        "default_landingURL": "https://bigads.co",
        "createAt": "2025-05-07 07:30:06",
        "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457537e4ef20d6f92219d51/1 (1).png",
                "createAt": "2025-05-07 07:30:06",
                "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2025-05-07 07:30:06",
        "scripts": {
            //eslint-disable-next-line
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"uw6PD7tU5NoD\"\r\n\tdata-unit=\"uw6PD7tU5NoD\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/uw6PD7tU5NoD/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n",
            "adcId": "6457537e4ef20d6f92219d51"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 0
    }

];

const media = [
    {             
        "id": "3eaa92cd-082b-45b2-9983-75c13e5549b2",
        "countryId": 15,
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "dspId": 2307,
        "currencyCode": "AUD",
        "name": "DOOH",
        "token": null,
        "card": "",
        "priceFloor": "35",
        "priceModel": "Fixed",
        "mediaType": "DOOH",
        "description": "",
        "topSites": "[{\"targeting_id\":\"rLopgQ\",\"value\":[\"qGZ7pL\"],\"index\":0},{\"targeting_id\":\"Bgn2gm\",\"value\":[\"GarRpL\",\"BLk32L\",\"ngb3x9\"],\"label\":[\"Atmosphere\",\"Motio\",\"QMS Media Limited\"],\"exclude\":false},{\"targeting_id\":\"wLznLb\",\"value\":{\"end\":\"2025-07-04T12:00:59.999Z\",\"start\":\"2025-07-03T21:00:00.000Z\"}},{\"targeting_id\":\"OLXqgA\",\"value\":[\"IMAGE\"]},{\"targeting_id\":\"KG4V0g\",\"value\":[\"Australian Capital Territory\",\"Tasmania\"],\"label\":[\"Australian Capital Territory\",\"Tasmania\"],\"exclude\":false},{\"targeting_id\":\"mGRJG2\",\"value\":[\"AG1JrL\",\"d9pnlL\",\"1978mG\",\"jgMwAG\",\"ELYmXL\"],\"label\":[\"Cloudy\",\"Clear/Sunny\",\"Dry\",\"Raining\",\"Mist\"],\"exclude\":false}]",
        "uniqueVisitors": "0",
        "adRequests": "378875.28996667",
        "audienceFact": "69",
        "audienceBehavior": "",
        "status": true,
        "createdBy": "83cd1860-8fd0-48bb-a6c4-99a639128ba0",
        "createdOn": "2025-07-03 02:42:13+00",
        "updatedOn": null,
        "updatedBy": null,
        "dealTypeId": "c7d08cf5-fb20-4544-8215-097aad2be281",
        "jobStatus": "Incoming",
        "numberOfSites": "55",
        "type": "DOOH",
        "live_date": "2025-07-03",
        "brief_date": "2025-07-03",
        "master_template_id": null,
        "internalNotes": "gWROpL-gnyzoL",
        "dealName": null,
        "dspBuyerId": "4487",
        "supplyPlatform": "Outmoove",
        "decarbonise": false,
        "dataProvider": "{\"provider\":\"\",\"provider_id\":\"\",\"segment_targeting\":\"\",\"provider_price\":\"\",\"provider_logo\":\"\",\"segment_targeting_category_ids\":\"\"}",
        "addon_booster": false
    }
];

const addons = null

const dealInfo = {
    "id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535g",    
    "countryId": 15,
    "currencyId": 4,
    "currencyCode": "AUD",
    "accountId": null,
    "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/c7d08cf5-fb20-4544-8215-097aad2be281/DOOH Image Landscape.png",
    "priceFloor": "30",
    "priceModel": "Fixed",
    "hasBespoke": false,
    "borderColor": "",
    "icon": null,
    "dealTypeFormatId": "0c260297-deca-4298-bfd8-0a75ed74d4fb",
    "device": "3",
    "kritikos": false,
    "channel": "Digital OOH",

    "accountName": "Nature",
    "networkName": "Nature",
    "name": "Ocean Spray DOOH",
    "decarbonise": "off",
    "measure_emissions": false,
    "dspId": 2249,
    "is_mobile_app": false,
    "dealType": "CCM",
    "createdBy": "admin",
    "createdOn": "2025-04-19 10:04:12",
    "updatedOn": Date.now(),
    "selectedMedias": "nature-medias",
    "status": 1,
    "ext_campaign_id_n": "nowhere",
    "ext_campaign_id_a": "nowhere",
    "userName": "Admin",
    "isDemo": false,
     addons: addons,
    
    "decarbonisation_option": 1,
    "decarbonise_options": "{\"format_category\":false,\"addons\":false,\"media\":false,\"addon_emission_selected\":0,\"max_addon_emission\":0,\"media_emission_selected\":350,\"max_media_emission\":350}",
    
}

export const MyDealsPageDataDOOH = {

    ...dealInfo,
    "creative": {
        "count": 2,
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457537e4ef20d6f92219d51/1 (1).png"
    },
    "curated-media": {
        "count": 1,
        "type": "DOOH"
    },
    "briefs": null,
    "slug_name": "the-trade-desk",
    "dsp": "The Trade Desk",
    "format_type": {
        "id": "c7d08cf5-fb20-4544-8215-097aad2be281",
        "borderColor": "",
        "icon": null,
        "name": "Image",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/c7d08cf5-fb20-4544-8215-097aad2be281/DOOH Image Landscape.png"
    },
    "is_tnc_accepted": true,
    channel: "Digital OOH",
}


export const GetCuratedAdDOOH = {
    "page-info": [
        {
            ...dealInfo,
            "createdByName": "Admin",
            "termsConditionsUrl": null,

        }
    ],
    "creative": creative,
    "curated-media": media,
    "briefs": null,
    "slug_name": "the-trade-desk",
    "updatedOn": Date.now(),
    "dsp": "The Trade Desk",
    "macros": {
        // eslint-disable-next-line 
        "click_url": "${CLICK_URL}",
        // eslint-disable-next-line 
        "cachebuster": "${CACHEBUSTER}"
    },
    "format_type": {
        "id": "c7d08cf5-fb20-4544-8215-097aad2be281",
        "borderColor": "",
        "icon": null,
        "name": "Image",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/c7d08cf5-fb20-4544-8215-097aad2be281/DOOH Image Landscape.png"
    },
    dealTypeInfo: {
        name: "Image",
        channel: "Digital OOH",
    },
    addons: addons

}

export const ActivityReportDOOH = {
  "result": [
    {
      "day": "2025-05-01",
      "impressions": 5312,
      "ad_played": 724,
      "audience_average": 7
    },
    {
      "day": "2025-05-02",
      "impressions": 5586,
      "ad_played": 749,
      "audience_average": 7
    },
    {
      "day": "2025-05-03",
      "impressions": 5855,
      "ad_played": 806,
      "audience_average": 7
    },
    {
      "day": "2025-05-04",
      "impressions": 5712,
      "ad_played": 754,
      "audience_average": 8
    },
    {
      "day": "2025-05-05",
      "impressions": 5757,
      "ad_played": 753,
      "audience_average": 8
    },
    {
      "day": "2025-05-06",
      "impressions": 5428,
      "ad_played": 735,
      "audience_average": 7
    },
    {
      "day": "2025-05-07",
      "impressions": 5167,
      "ad_played": 705,
      "audience_average": 7
    }
  ],
  "summary": {
    "impressions": 38817,
    "ad_played": 5226,
    "audience_average": 7
  },
  "creatives": [
    {
      "creativeName": "Ocean Spray Landscape",
      "impressions": 19546,
      "ad_played": 2596,
      "audience_average": 8
    },
    {
      "creativeName": "Ocean Spray Portrait",
      "impressions": 19271,
      "ad_played": 2630,
      "audience_average": 7
    }
  ],
  "sizes": [
    {
      "size": "1080x1920",
      "impressions": 19271,
      "ad_played": 2630,
      "audience_average": 7
    },
    {
      "size": "1920x1080",
      "impressions": 19546,
      "ad_played": 2596,
      "audience_average": 8
    }
  ],
  "publishers": [
    {
      "name": "Adstash",
      "impressions": 2525,
      "ad_played": 322,
      "audience_average": 8
    },
    {
      "name": "Atmosphere",
      "impressions": 4000,
      "ad_played": 579,
      "audience_average": 7
    },
    {
      "name": "Framen",
      "impressions": 4916,
      "ad_played": 654,
      "audience_average": 8
    },
    {
      "name": "JCDecaux AU",
      "impressions": 5635,
      "ad_played": 766,
      "audience_average": 7
    },
    {
      "name": "Motio",
      "impressions": 4657,
      "ad_played": 634,
      "audience_average": 7
    },
    {
      "name": "QMS Media Limited",
      "impressions": 9233,
      "ad_played": 1242,
      "audience_average": 7
    },
    {
      "name": "Tonic Media Network",
      "impressions": 4104,
      "ad_played": 544,
      "audience_average": 8
    },
    {
      "name": "Val Morgan Outdoor",
      "impressions": 3747,
      "ad_played": 485,
      "audience_average": 8
    }
  ],
  "screens": [
  {
    "name": "106453 at 227 Elizabeth Street Sydney",
    "publisher": "Adstash",
    "latitude": -33.874382,
    "longitude": 151.20937,
    "impressions": 1018,
    "ad_played": 126,
    "audience_average": 8
  },
  {
    "name": "134719 at 83 York Street Sydney",
    "publisher": "Adstash",
    "latitude": -33.869343,
    "longitude": 151.20595,
    "impressions": 795,
    "ad_played": 103,
    "audience_average": 8
  },
  {
    "name": "1503  . Hyde Park Medical Centre",
    "publisher": "Tonic Media Network",
    "latitude": -33.87717,
    "longitude": 151.21065,
    "impressions": 671,
    "ad_played": 93,
    "audience_average": 7
  },
  {
    "name": "1503 . Hyde Park Medical Centre",
    "publisher": "Tonic Media Network",
    "latitude": -33.87717,
    "longitude": 151.21065,
    "impressions": 1026,
    "ad_played": 126,
    "audience_average": 8
  },
  {
    "name": "166 . Sydney Premier Medical And Health Centre",
    "publisher": "Tonic Media Network",
    "latitude": -33.87377,
    "longitude": 151.20776,
    "impressions": 799,
    "ad_played": 109,
    "audience_average": 7
  },
  {
    "name": "3137  . Sydney Doctors",
    "publisher": "Tonic Media Network",
    "latitude": -33.8662,
    "longitude": 151.20897,
    "impressions": 825,
    "ad_played": 113,
    "audience_average": 7
  },
  {
    "name": "6782 . Medicentral 501 George Street",
    "publisher": "Tonic Media Network",
    "latitude": -33.87476,
    "longitude": 151.20602,
    "impressions": 783,
    "ad_played": 103,
    "audience_average": 8
  },
  {
    "name": "70551 at 22 Pitt Street Sydney",
    "publisher": "Adstash",
    "latitude": -33.862083,
    "longitude": 151.20935,
    "impressions": 712,
    "ad_played": 93,
    "audience_average": 8
  },
  {
    "name": "AB1019AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.871674,
    "longitude": 151.20647,
    "impressions": 930,
    "ad_played": 113,
    "audience_average": 8
  },
  {
    "name": "AB1019BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.871674,
    "longitude": 151.20647,
    "impressions": 748,
    "ad_played": 98,
    "audience_average": 8
  },
  {
    "name": "AB1027AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.872276,
    "longitude": 151.20824,
    "impressions": 695,
    "ad_played": 87,
    "audience_average": 8
  },
  {
    "name": "AB1027BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.872276,
    "longitude": 151.20824,
    "impressions": 762,
    "ad_played": 116,
    "audience_average": 7
  },
  {
    "name": "AB1033AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.870907,
    "longitude": 151.20532,
    "impressions": 748,
    "ad_played": 102,
    "audience_average": 7
  },
  {
    "name": "AB1033BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.870907,
    "longitude": 151.20532,
    "impressions": 774,
    "ad_played": 98,
    "audience_average": 8
  },
  {
    "name": "AB1059AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.865067,
    "longitude": 151.2054,
    "impressions": 761,
    "ad_played": 108,
    "audience_average": 7
  },
  {
    "name": "AB1059BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.865067,
    "longitude": 151.2054,
    "impressions": 717,
    "ad_played": 103,
    "audience_average": 7
  },
  {
    "name": "Anytime Fitness - Circular Quay",
    "publisher": "Atmosphere",
    "latitude": -33.862007,
    "longitude": 151.20929,
    "impressions": 815,
    "ad_played": 117,
    "audience_average": 7
  },
  {
    "name": "Anytime Fitness - Hyde Park",
    "publisher": "Atmosphere",
    "latitude": -33.874382,
    "longitude": 151.20937,
    "impressions": 840,
    "ad_played": 111,
    "audience_average": 8
  },
  {
    "name": "B1018BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.864517,
    "longitude": 151.2089,
    "impressions": 740,
    "ad_played": 95,
    "audience_average": 8
  },
  {
    "name": "B1031AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.867405,
    "longitude": 151.21072,
    "impressions": 753,
    "ad_played": 104,
    "audience_average": 7
  },
  {
    "name": "B1031BD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.867405,
    "longitude": 151.21072,
    "impressions": 874,
    "ad_played": 118,
    "audience_average": 7
  },
  {
    "name": "B1033AD City of Sydney",
    "publisher": "QMS Media Limited",
    "latitude": -33.868114,
    "longitude": 151.21213,
    "impressions": 731,
    "ad_played": 100,
    "audience_average": 7
  },
  {
    "name": "C-NSW-Due_Mondi_@_Society-01",
    "publisher": "Motio",
    "latitude": -33.87244,
    "longitude": 151.20715,
    "impressions": 761,
    "ad_played": 107,
    "audience_average": 7
  },
  {
    "name": "C-NSW-Good_And_Co-01",
    "publisher": "Motio",
    "latitude": -33.86491,
    "longitude": 151.20505,
    "impressions": 773,
    "ad_played": 98,
    "audience_average": 8
  },
  {
    "name": "C-NSW-Happy_Bones-01",
    "publisher": "Motio",
    "latitude": -33.86809,
    "longitude": 151.21083,
    "impressions": 668,
    "ad_played": 98,
    "audience_average": 7
  },
  {
    "name": "C-NSW-Joe_Black_Cafe-01",
    "publisher": "Motio",
    "latitude": -33.87783,
    "longitude": 151.21082,
    "impressions": 825,
    "ad_played": 107,
    "audience_average": 8
  },
  {
    "name": "C-NSW-Kafe_Kaz-01",
    "publisher": "Motio",
    "latitude": -33.876858,
    "longitude": 151.20757,
    "impressions": 820,
    "ad_played": 109,
    "audience_average": 8
  },
  {
    "name": "C-NSW-Lennox_Espresso-01",
    "publisher": "Motio",
    "latitude": -33.87122,
    "longitude": 151.20451,
    "impressions": 810,
    "ad_played": 115,
    "audience_average": 7
  },
  {
    "name": "Inski",
    "publisher": "Atmosphere",
    "latitude": -33.87009,
    "longitude": 151.2049,
    "impressions": 784,
    "ad_played": 119,
    "audience_average": 7
  },
  {
    "name": "JCDecaux 02134.13.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.867744,
    "longitude": 151.21117,
    "impressions": 822,
    "ad_played": 117,
    "audience_average": 7
  },
  {
    "name": "JCDecaux 03807.02.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.86134,
    "longitude": 151.21039,
    "impressions": 757,
    "ad_played": 96,
    "audience_average": 8
  },
  {
    "name": "JCDecaux 03808.02.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.86139,
    "longitude": 151.21092,
    "impressions": 908,
    "ad_played": 117,
    "audience_average": 8
  },
  {
    "name": "JCDecaux 03809.02.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.86117,
    "longitude": 151.21042,
    "impressions": 767,
    "ad_played": 95,
    "audience_average": 8
  },
  {
    "name": "JCDecaux 03810.02.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.86122,
    "longitude": 151.21095,
    "impressions": 891,
    "ad_played": 119,
    "audience_average": 7
  },
  {
    "name": "JCDecaux 03817.01.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.87314,
    "longitude": 151.2069,
    "impressions": 802,
    "ad_played": 109,
    "audience_average": 7
  },
  {
    "name": "JCDecaux 03818.02.01",
    "publisher": "JCDecaux AU",
    "latitude": -33.873066,
    "longitude": 151.20702,
    "impressions": 688,
    "ad_played": 113,
    "audience_average": 6
  },
  {
    "name": "Paul Reader Snow Sports",
    "publisher": "Atmosphere",
    "latitude": -33.869343,
    "longitude": 151.20595,
    "impressions": 768,
    "ad_played": 107,
    "audience_average": 7
  },
  {
    "name": "SHOP REACH - NSW 201 Elizabeth Street - Food Court A -PORTRAIT",
    "publisher": "Val Morgan Outdoor",
    "latitude": -33.873444,
    "longitude": 151.20956,
    "impressions": 671,
    "ad_played": 85,
    "audience_average": 8
  },
  {
    "name": "SHOP REACH - NSW 201 Elizabeth Street - Food Court B -PORTRAIT",
    "publisher": "Val Morgan Outdoor",
    "latitude": -33.873444,
    "longitude": 151.20956,
    "impressions": 800,
    "ad_played": 99,
    "audience_average": 8
  },
  {
    "name": "SHOP REACH - NSW Australia Square - Food Court A -PORTRAIT",
    "publisher": "Val Morgan Outdoor",
    "latitude": -33.86503,
    "longitude": 151.20757,
    "impressions": 909,
    "ad_played": 115,
    "audience_average": 8
  },
  {
    "name": "SHOP REACH - NSW Australia Square - Food Court B -PORTRAIT",
    "publisher": "Val Morgan Outdoor",
    "latitude": -33.86474,
    "longitude": 151.20793,
    "impressions": 823,
    "ad_played": 104,
    "audience_average": 8
  },
  {
    "name": "SHOP REACH - NSW Kent Street Tunnel - Shop -Standard",
    "publisher": "Val Morgan Outdoor",
    "latitude": -33.865818,
    "longitude": 151.2046,
    "impressions": 544,
    "ad_played": 82,
    "audience_average": 7
  },
  {
    "name": "SYD02 - WeWork (Martin Place) + Level 14 Lobby",
    "publisher": "Framen",
    "latitude": -33.86802,
    "longitude": 151.20871,
    "impressions": 721,
    "ad_played": 103,
    "audience_average": 7
  },
  {
    "name": "SYD03 - Wework (333 George Street) + Level 05",
    "publisher": "Framen",
    "latitude": -33.866814,
    "longitude": 151.20688,
    "impressions": 741,
    "ad_played": 100,
    "audience_average": 7
  },
  {
    "name": "SYD04 - Wework (383 George St) + Level 02 Kitchen",
    "publisher": "Framen",
    "latitude": -33.86932,
    "longitude": 151.20668,
    "impressions": 631,
    "ad_played": 89,
    "audience_average": 7
  },
  {
    "name": "SYD05 - Wework (64 York St) - Potrait + Level 09",
    "publisher": "Framen",
    "latitude": -33.869835,
    "longitude": 151.20633,
    "impressions": 943,
    "ad_played": 113,
    "audience_average": 8
  },
  {
    "name": "SYD08 - 161 Castlereagh Street (Horizontal) + Level 26 Lift",
    "publisher": "Framen",
    "latitude": -33.872215,
    "longitude": 151.2091,
    "impressions": 829,
    "ad_played": 117,
    "audience_average": 7
  },
  {
    "name": "SYD10 - Wework (320 Pitt St) - Potrait + Level 02",
    "publisher": "Framen",
    "latitude": -33.875317,
    "longitude": 151.20811,
    "impressions": 1051,
    "ad_played": 132,
    "audience_average": 8
  },
  {
    "name": "Snap Fitness - Sydney City - Sydney - 2080",
    "publisher": "Atmosphere",
    "latitude": -33.864265,
    "longitude": 151.20456,
    "impressions": 793,
    "ad_played": 125,
    "audience_average": 6
  }
]
}